var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center align-items-center spinner",attrs:{"id":"fullscreen-loading"}},[_c('div',{staticClass:"spinner-border text-primary",attrs:{"role":"status"}})])
}]

export { render, staticRenderFns }